<template>
  <div id="app">
    <my-header></my-header>
    <router-view/>
    <my-footer v-show="$route.name != 'negotiation'"></my-footer>
  </div>
</template>
<script>
import MyHeader from '@/components/header';
import MyFooter from '@/components/footer';
export default {
  components:{
    MyHeader,
    MyFooter
  }
}
</script>
<style lang="scss" src="./assets/css/common.scss"></style>
